import type { MindMapNode } from '@/model/types';

/**
 * Compute the extra height needed inside a node rect to display
 * inline link rows and image-attachment badges below the text.
 */
export function computeNodeExtraHeight(node: MindMapNode): number {
  let extraHeight = 0;

  if (node.links && node.links.length > 0) {
    const shownLinks = Math.min(node.links.length, 3);
    extraHeight += shownLinks * 16 + 8; // 16px per link row + 8px padding
    if (node.links.length > 3) {
      extraHeight += 14; // "+N more" line
    }
  }

  if (node.attachments) {
    const imageCount = node.attachments.filter(a => a.mimeType.startsWith('image/')).length;
    if (imageCount > 0) {
      const shownImages = Math.min(imageCount, 2);
      extraHeight += shownImages * 64 + 6; // 60px thumbnail + 4px gap per image + 6px padding
    }
  }

  return extraHeight;
}
